import lowerCase from 'lodash/lowerCase';

export function trackFormErrorsWithHeap(fieldType, fieldValue) {
  if (window.heap) {
    window.heap.track('Enterprise Form Error', {
      fieldType,
      fieldValue,
    });
  }
}

export function isRequired(val, allValues, props, name) {
  return val ? undefined : `Please enter your ${lowerCase(name)}`;
}

// for fields that require just error state and no error message, e.g. dropdown
export function shouldBeSelected(val) {
  return val ? undefined : true;
}

export function isEmailValid(val) {
  const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const isValid =
    val && emailRegex.test(val.trim())
      ? undefined
      : 'Please enter a valid email address';
  if (isValid !== undefined) {
    trackFormErrorsWithHeap('emailField', val);
  }
  return isValid;
}

export function isPhoneNumberValid(val) {
  const phoneNumberRegex = /^\+?[0-9\s]*$/;
  const isValid =
    val && phoneNumberRegex.test(val.trim())
      ? undefined
      : 'Should only contain numbers, spaces and + symbol';
  if (!isValid) {
    trackFormErrorsWithHeap('phoneField', val);
  }
  return isValid;
}

export function minLength(min) {
  return function(value) {
    const isValid =
      value && value.length < min
        ? `Must be ${min} characters or more`
        : undefined;
    if (!isValid) {
      trackFormErrorsWithHeap('minLength', value);
    }
    return isValid;
  };
}



// WEBPACK FOOTER //
// ./src/utils/forms/validation.js